import React, { useRef, useContext, useEffect, useState } from "react";
import { Navigation, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";

import { TrustedCommunitys } from "../../../utils/apis/homepage/index";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";

// Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "./Trusted_Communities.css";

const Trusted_Communities = () => {
  const swiperRef = useRef(null);
  const { IMG_URL } = useContext(Context);
  const [trusted, setTrusted] = useState([]);

  const getTrusted = async () => {
    const res = await TrustedCommunitys();
    if (res?.success) {
      setTrusted(res.data || []);
    }
  };

  useEffect(() => {
    getTrusted();
  }, []);

  return (
    <section className="Trusted_Communities">
      {/* Decorative Server Room Ambient Light Blobs */}
      <div className="tech_ambient_blur_1"></div>
      <div className="tech_ambient_blur_2"></div>

      <div className="container">
        {/* Main High-Tech Dashboard Container Frame */}
        <div className="glass_panel_container">
          <div className="row g-0 align-items-stretch">
            
            {/* Left Column: Information Display Deck */}
            <div className="col-lg-5 text_display_deck">
              <div className="deck_content_wrapper">
                <h2 className="tech_title_main">
                  Trusted
                  <span className="cyan_badge_highlight">Across Industries</span>
                </h2>
                <p className="tech_description_text">
                  Powering innovative technology solutions, secure network operations, 
                  and robust cloud infrastructure for leading enterprise brands and local businesses.
                </p>
                
                {/* Micro-scale abstract world node vector element */}
                <div className="abstract_globe_node"></div>
              </div>
            </div>

            {/* Right Column: Interactive Carousel Module Container */}
            <div className="col-lg-7 logo_carousel_module">
              
              <div className="swiper_viewport_wrapper">
                <Swiper
                  modules={[Navigation, Autoplay]}
                  spaceBetween={25}
                  slidesPerView={2}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                  }}
                  onSwiper={(swiper) => (swiperRef.current = swiper)}
                  loop={trusted.length > 3}
                  breakpoints={{
                    320: { slidesPerView: 2, spaceBetween: 15 },
                    576: { slidesPerView: 3, spaceBetween: 20 },
                    992: { slidesPerView: 2, spaceBetween: 20 },
                    1200: { slidesPerView: 3, spaceBetween: 25 },
                  }}
                  className="trustedSwiper"
                >
                  {trusted.map((item, index) => (
                    <SwiperSlide key={item.id || index}>
                      <div className="glass_logo_card">
                        <div className="logo_inner_box">
                          <img
                            src={IDS?.IMG_URL + item?.image}
                            alt={item?.title || "Corporate Client Identity Logo"}
                            className="partner_logo_img"
                            onError={(e) => {
                              e.target.style.opacity = "0.4";
                            }}
                          />
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>

              {/* Bottom Right Symmetrical Cyan Navigation Console */}
              <div className="cyan_console_nav">
                <button
                  className="console_btn"
                  onClick={() => swiperRef.current?.slidePrev()}
                  type="button"
                  aria-label="Previous Slide"
                >
                  <FontAwesomeIcon icon={faArrowLeft} />
                </button>

                <button
                  className="console_btn"
                  onClick={() => swiperRef.current?.slideNext()}
                  type="button"
                  aria-label="Next Slide"
                >
                  <FontAwesomeIcon icon={faArrowRight} />
                </button>
              </div>

            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Trusted_Communities;